import { Vendor, Contact } from '../../definitions/vendor';
import { PurchaseOrder } from '../../definitions/sensor';
import { Client, Site } from '../../definitions/client';

export const prepareVendorSelect = (vendors: Vendor[]) => vendors.map(({ name, id }) => ({ id , description: name}));

export const prepareVendorContactsSelect = (vendorsContacts: Contact[]) => vendorsContacts.map(({ name, id }) => ({ id , description: name}));

export const preparePurchaseOrdersSelect = (purchaseOrders: PurchaseOrder[]) => purchaseOrders.map(({ number, id }) => ({ id , description: number}));

// Alphabetical order, except "No Client" which is always listed first
const noClientFirst = (a: { description: string }, b: { description: string }) => {
  if (a.description.toLowerCase() === 'no client') return -1;
  if (b.description.toLowerCase() === 'no client') return 1;
  return a.description.localeCompare(b.description);
};

export const prepareClientsSelect =
  (purchaseOrders: Client[], isCustomerRequired?: boolean) => {
    const clients = isCustomerRequired
      ? purchaseOrders.filter(({ isClient }) => isClient)
      : purchaseOrders;
    return clients
      .map(({ name, id, isClient }) => ({ id, description: isClient ? name : 'No client' }))
      .sort(noClientFirst);
  };

export const prepareSiteSelect = (sites: Site[]) => sites.map(({ name, id }) => ({ id , description: name}));
